"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.Environment = void 0;

/*
 * Generate the cdn url based on the current stage environment
 * stage: Environment.production | Environment.staging
 * returns string
 */
var Environment;
exports.Environment = Environment;

(function (Environment) {
  Environment["PRODUCTION"] = "production";
  Environment["STAGING"] = "staging";
  Environment["DEVELOPMENT"] = "development";
})(Environment || (exports.Environment = Environment = {}));

;

var getCdnUrl = function getCdnUrl(stage) {
  return stage.toLowerCase() === Environment.PRODUCTION ? 'https://cdn.gymshark.com/' : 'https://cdn.staging.gymshark.com/';
};

exports["default"] = getCdnUrl;